import axios from 'axios';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import env from '../../environment';

const Home = () => {
	const navigate = useNavigate();
	const dataSummary = useSelector((state) => state.data.dataSummary);
    const userToken = useSelector((state) => state.auth.token);

	useEffect(() => {
		if (dataSummary.length > 0 ) {
			getOperationData(dataSummary[0]);
		}else {
            navigate('/operationNew');

        }
	}, [dataSummary]);

	useEffect(() => {
		if (dataSummary.length > 0 ) {
			getOperationData(dataSummary[0]);
		}else {
            navigate('/operationNew');

        }
	}, []);

	const getOperationData = (operation) => {
		axios
			.get(`${env.api.url}/operations/operation/operationData/${operation.operationId}/client`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					if (response.data.data.process.operationTypeToBeDefined) {
						navigate('/operationNew');
					} else {
						navigate(`/operations/${operation.operationId}/${operation.stage}`);
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return <></>;
};

export default Home;
